<app-list-module-table
    variant="surface"
    [columns]="columns"
    [rows]="rows"
    [loading]="loading"
    [emptyMessage]="emptyMessage"
    rowTrackKey="sessionId"
>
    <ng-template listCellDef="serial" let-row="row">{{ row.srNo }}</ng-template>

    <ng-template listCellDef="customer" let-row="row">{{ row.customerName }}</ng-template>

    <ng-template listCellDef="agent" let-row="row">
        <span class="text-sm text-gray-600 dark:text-gray-300">{{ row.agentName }}</span>
    </ng-template>

    <ng-template listCellDef="activity" let-row="row">
        <span class="line-clamp-2 text-sm text-gray-600 dark:text-gray-300">{{ row.description }}</span>
    </ng-template>

    <ng-template listCellDef="status" let-row="row">
        <span [class]="statusBadgeClass(row.status)">
            {{ row.status }}
        </span>
    </ng-template>

    <ng-template listCellDef="date" let-row="row">{{ row.created_at | appDate }}</ng-template>

    <ng-template listCellDef="actions" let-row="row">
        @if (P.AUDIT_TRAIL_VIEW | hasPermission) {
        <div class="inline-flex items-center justify-end gap-1">
            <button
                type="button"
                class="inline-flex h-9 w-9 items-center justify-center rounded-lg text-primary hover:bg-primary/10"
                title="View"
                aria-label="View"
                (click)="view.emit(row)"
            >
                <icon-eye class="h-4 w-4" />
            </button>
        </div>
        } @else {
            <span class="text-xs text-gray-400">—</span>
        }
    </ng-template>
</app-list-module-table>
